import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { SharedModule } from 'src/app/shared/shared.module';
import { UsersInRoleComponent } from './role-edition/users-in-role/users-in-role.component';
import { AlcmeonRolesComponent } from './roles/alcmeon-roles/alcmeon-roles.component';
import { CompanyRolesComponent } from './roles/company-roles/company-roles.component';
import { RolesComponent } from './roles/roles.component';
import { BusinessHoursComponent } from './shared/business-hours/business-hours.component';
import { TeamsComponent } from './teams/teams.component';
import { UsersPermissionsComponent } from './users-permissions/users-permissions.component';
import { RolesForUserComponent } from './users/user-edition/roles-for-user/roles-for-user.component';
import { UsersComponent } from './users/users.component';

@NgModule({
  declarations: [
    AlcmeonRolesComponent,
    BusinessHoursComponent,
    CompanyRolesComponent,
    RolesComponent,
    RolesForUserComponent,
    TeamsComponent,
    UsersComponent,
    UsersPermissionsComponent,
    UsersInRoleComponent,
  ],
  imports: [BrowserModule, CommonModule, SharedModule],
})
export class UsersModule {}
